import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { BasicTableHead } from './BasicTableHead';
import { BasicHeadCell } from '../../../models/BasicTable/BasicTableProps';

export const BasicTable = <T, S>(props: BasicTableProps<T, S>) => {
    const { tableHeadSettings, component, fullList, handleChange } = props;

    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <BasicTableHead<S>
                    headContent={tableHeadSettings.headContent}
                    translateNs={tableHeadSettings.translateNs}
                    translatePrefix={tableHeadSettings.translatePrefix}
                />
                <TableBody>
                    {fullList.map((row, index) => {
                        return React.createElement(component, {
                            key: index,
                            row: row,
                            index: index,
                            handleChange: handleChange,
                        });
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

interface BasicTableProps<T, S> {
    fullList: T[];
    component: any;
    tableHeadSettings: {
        headContent: BasicHeadCell<S>[];
        translateNs: string;
        translatePrefix: string;
    };
    handleChange?: (props: any) => void;
}
